import { FeatureDefinition } from "../../types/feature-loader";
import { isFeatureEnabled } from "./config";
import * as actions from "./flex-actions";
import * as hooks from "./flex-hooks";

export const register = (): FeatureDefinition => {
  if (!isFeatureEnabled()) return {};
  return {
    name: "conversation-transfer",
    hooks: typeof hooks === "undefined" ? [] : Object.values(hooks),
    actions: typeof actions === "undefined" ? [] : Object.values(actions)
  };
};
